// extracted by mini-css-extract-plugin
module.exports = {"layout":"MobileLayout_layout__2Au8p","empty":"MobileLayout_empty__1n3gc","emptyBottom":"MobileLayout_emptyBottom__1vP14","main":"MobileLayout_main__1dpUO"};